// Bootstrap Framework
import "regenerator-runtime/runtime";
import './scss/index.scss';
import jquery, { merge } from "jquery";
window.$ = window.jQuery = jquery;
import 'popper.js';
import 'bootstrap';

import "slick-carousel";
import 'jquery-match-height';

import '@fancyapps/fancybox';

import axios from "axios";
import Vue from "vue";
import vSelect from "vue-select";

Vue.component("v-select", vSelect);

$(function () {

    //#region Configurazioni

    const Lang = $("[name*=lang]").attr("id");

    //#endregion

    //#region header language
    $('.header__language__current').on('click', function (e) {
        e.preventDefault();
        $('.header__language__dropdown').toggleClass('open');
    });
    //#endregion

    //#region header slider
    $('.header__slider').slick({
        fade: true,
        dots: true,
        prevArrow: '.header__slider__arrow--prev',
        nextArrow: '.header__slider__arrow--next',
    });
    //#endregion

    //#region nav
    $('.nav__toggler').on('click', function (e) {
        e.preventDefault();
        $('.nav').addClass('open');
    });
    $('.nav__close').on('click', function (e) {
        e.preventDefault();
        $('.nav').removeClass('open');
    });
    $('.nav__item--parent').on('click', function (e) {
        e.preventDefault();
        $('.nav__item--parent').not(this).removeClass('open');
        $(this).toggleClass('open');
        $('.nav__submenu').not(this).removeClass('open');
        $(this).next('.nav__submenu').toggleClass('open');
    });
    //#endregion

    //#region carousel
    $('.carousel').each(function () {
        let prevArrow = $(this).parent().find('.carousel__arrow--prev');
        let nextArrow = $(this).parent().find('.carousel__arrow--next');
        let cols = $(this).data('cols');
        $(this).slick({
            slidesToShow: cols,
            slidesToScroll: 1,
            infinite: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    });
    //#endregion

    //#region box caption same height
    $('.box__caption').matchHeight();
    //#endregion

    //#region menu on scroll

        $(document).on('scroll', function () {
            var y = $(this).scrollTop();
            if (y > 350) {
                $('.mini-logo').fadeIn();
                $('.header__utils').addClass('header__utils--resized');
            } else {
                $('.mini-logo').fadeOut();
                $('.header__utils').removeClass('header__utils--resized');
            }


        });
    
        //#endregion

    //#region lista attivita
    const divListaAttivita = document.getElementById("divListaAttivita");
    if (divListaAttivita) {
        const vueListaAttivita = new Vue({
            el: "#divListaAttivita",
            data() {
                return {
                    categories: [],
                    categoriesSchemaKey: "pinocchio-category",
                    categoriesLoading: true,
                    activities: [],
                    activitiesSchemaKey: "pinocchio-attivita",
                    activitiesLoading: true,
                    Limit: 50,
                    Page: 1,
                    LanguageId: Lang,
                    SelectedCategory: []
                };
            },
            async mounted() {
                //categorie
                var Categories = await this.asyncGetCategories(this.categoriesSchemaKey, this.LanguageId, 1, 100, "", "");
                if (Categories) {
                    for (var i = 0; i < Categories.length; i++) {
                        //console.log(Categories[i]);
                        if (Categories[i].ContentDecoded && Categories[i].GenericContentDecoded && Categories[i].EntityId) {
                            var category = {
                                Id: Categories[i].EntityId,
                                Name: Categories[i].ContentDecoded.categoryname ? Categories[i].ContentDecoded.categoryname : "",
                                Img: this.GetImageByCategory(Categories[i].GenericContentDecoded.color)
                            };
                        }
                        this.categories.push(category);
                    }

                    this.categoriesLoading = false
                }

                //attivita
                await this.FilterActivites();
            },
            methods: {
                asyncGetCategories: function (_CategoriesSchemaKey, _LanguageId, _Page, _Limit, _FieldName, _FilterValue) {
                    return new Promise((resolve, reject) => {
                        axios({
                            method: 'get',
                            url: '/GetEntitiesBySchemaKey',
                            params: {
                                ElementSchemaKey: _CategoriesSchemaKey,
                                Limit: _Limit,
                                Page: _Page,
                                LanguageId: _LanguageId,
                                FieldName: _FieldName,
                                FilterValue: _FilterValue
                            }
                        })
                        .then(response => {
                            //console.log(response.data);
                            resolve(response.data);
                        })
                        .catch(error => { console.log(error); })
                        .finally()
                    })
                },
                asyncGetActivites: function (_ActiviesSchemaKey, _LanguageId, _Page, _Limit, _FieldName, _FilterValue) {
                    return new Promise((resolve, reject) => {
                        axios({
                            method: 'get',
                            url: '/GetEntitiesBySchemaKey',
                            params: {
                                ElementSchemaKey: _ActiviesSchemaKey,
                                Limit: _Limit,
                                Page: _Page,
                                LanguageId: _LanguageId,
                                FieldName: _FieldName,
                                FilterValue: _FilterValue
                            }
                        })
                        .then(response => {
                            //console.log(response.data);
                            resolve(response.data);
                        })
                        .catch(error => { console.log(error); })
                        .finally()
                    })
                },
                asyncGetImageById: function (ImageId) {
                    if (ImageId) {
                        return new Promise((resolve, reject) => {
                            axios({
                                method: 'get',
                                url: '/GetImageName',
                                params: {
                                    EntityId: ImageId,
                                    LanguageId: this.LanguageId
                                }
                            })
                            .then(response => {
                                //console.log(response.data);
                                resolve(response.data);
                            })
                            .catch(error => { console.log(error); })
                            .finally()
                        })
                    }
                },
                async FilterActivites() {
                    this.activities = [];
                    this.activitiesLoading = true;

                    var Activities = await this.asyncGetActivites(this.activitiesSchemaKey, this.LanguageId, this.Page, this.Limit, "attivita-category", this.SelectedCategory.join());
                    if (Activities) {
                        for (var i = 0; i < Activities.length; i++) {

                            if (Activities[i].ContentDecoded && Activities[i].GenericContentDecoded) {

                                //console.log(Activities[i].ContentDecoded);

                                var GuidImage = (Activities[i].GenericContentDecoded.main && Activities[i].GenericContentDecoded.main.image && Activities[i].GenericContentDecoded.main.image.length > 0) ? Activities[i].GenericContentDecoded.main.image[0].entityId : "";

                                var Activity = {
                                    EntityId: Activities[i].EntityId,
                                    Link:  "../" + this.LanguageId + "/" + Activities[i].ContentDecoded.slug,
                                    Image: await this.asyncGetImageById(GuidImage),
                                    Title: Activities[i].ContentDecoded.meta ? Activities[i].ContentDecoded.meta.title : "",
                                    Content: Activities[i].ContentDecoded.meta ? Activities[i].ContentDecoded.meta.description : ""
                                };


                                this.activities.push(Activity);
                            }
                        }
                    }

                    this.activitiesLoading = false
                },
                GetImageByCategory(category) {
                    var retval = "";
                    switch (category) {
                        case category = "parco_pinocchio":
                            retval = "1";
                            break;
                        case category = "giardino_garzoni":
                            retval = "2";
                            break;
                        case category = "casa_farfalle":
                            retval = "3";
                            break;
                        case category = "territorio_collodi":
                            retval = "4";
                            break;
                    }

                    return retval;
                },
                CheckChange(event, id) {
                    const index = this.SelectedCategory.indexOf(id);
                    if (index > -1) {
                        this.SelectedCategory.splice(index, 1);
                    }
                    else {
                        this.SelectedCategory.push(id);
                    }
                },
                async Reset(event) {
                    event.preventDefault();

                    var $categorycheked = $('input[name=activiycategory]:checked');
                    $categorycheked.each(function () {
                        $(this).prop('checked', false);
                    });

                    this.SelectedCategory = [];
                    await this.FilterActivites();
                },
                async Filter(event) {
                    event.preventDefault();

                    await this.FilterActivites();
                }
            }
        });
    }
    //#endregion

    //#region Mappa Parco
    const divMappaPinocchio = document.getElementById("divMappaPinocchio");
    if (divMappaPinocchio) {
        const vueMappaPinocchio = new Vue({
            el: "#divMappaPinocchio",
            data() {
                return {
                    Limit: 500,
                    Page: 1,
                    LanguageId: Lang,
                    Stores: [],
                    AreeTematiche: [],
                    SelectedAreeTematiche: [],
                    PuntiStorici: [],
                    SelectedPuntiStorici: [],
                    Servizi: [],
                    SelectedServizi: [],
                    Icons: []
                };
            },
            async mounted() {

                this.AreeTematiche = await this.asyncGetFilters("pinocchio-store-areatematica", this.LanguageId, this.Page, this.limit);
                this.PuntiStorici = await this.asyncGetFilters("pinocchio-store-puntoristoro", this.LanguageId, this.Page, this.limit);
                this.Servizi = await this.asyncGetFilters("pinocchio-store-servizio", this.LanguageId, this.Page, this.limit);

                //#region Filtri Query String
                const urlParams = new URLSearchParams(window.location.search);
                var at = urlParams.get('at');
                if (at) {
                    var array = at.split(',');
                    if (array) {
                        for (var i = 0; i < array.length; i++) {
                            var index = this.AreeTematiche.findIndex(e => e.EntityId === array[i]);
                            if (index >= 0) {
                                this.SelectedAreeTematiche.push(this.AreeTematiche[index]);
                            }
                        }
                    }
                }

                var ps = urlParams.get('ps');
                if (ps) {
                    var array = ps.split(',');
                    if (array) {
                        for (var i = 0; i < array.length; i++) {
                            var index = this.PuntiStorici.findIndex(e => e.EntityId === array[i]);
                            if (index >= 0) {
                                this.SelectedPuntiStorici.push(this.PuntiStorici[index]);
                            }
                        }
                    }
                }

                var sv = urlParams.get('sv');
                if (sv) {
                    var array = sv.split(',');
                    if (array) {
                        for (var i = 0; i < array.length; i++) {
                            var index = this.Servizi.findIndex(e => e.EntityId === array[i]);
                            if (index >= 0) {
                                this.SelectedServizi.push(this.Servizi[index]);
                            }
                        }
                    }
                }
                //#endregion


                this.Icons = this.ParseIcons();

                this.Stores = await this.asyncGetStores(this.LanguageId, this.Page, this.limit, this.SelectedAreeTematiche, this.SelectedPuntiStorici, this.SelectedServizi);
                if (this.Stores) {
                    this.SetStoreLocator(this.Stores, this.Icons);
                }
            },
            methods: {
                asyncGetStores: function (_LanguageId, _Page, _Limit, _SelectedAreeTematiche, _SelectedPuntiStorici, _SelectedServizi) {
                   
                    return new Promise((resolve, reject) => {
                        axios({
                            method: 'get',
                            url: '../GetStores',
                            params: {                            
                                Limit: _Limit,
                                Page: _Page,
                                LanguageId: _LanguageId,
                                SelectedAreeTematiche: this.ArrayToString(_SelectedAreeTematiche),
                                SelectedPuntiStorici: this.ArrayToString(_SelectedPuntiStorici),
                                SelectedServizi: this.ArrayToString(_SelectedServizi)
                            }
                        })
                        .then(response => {
                            //console.log(response.data);
                            resolve(response.data);
                        })
                        .catch(error => { console.log(error); })
                        .finally()
                    })
                },
                asyncGetFilters: function (_SchemaKey, _LanguageId, _Page, _Limit) {
                    return new Promise((resolve, reject) => {
                        axios({
                            method: 'get',
                            url: '../GetFiltersStore',
                            params: {
                                FilterType: _SchemaKey,
                                Limit: _Limit,
                                Page: _Page,
                                LanguageId: _LanguageId
                            }
                        })
                        .then(response => {
                            //console.log(response.data);
                            resolve(response.data);
                        })
                        .catch(error => { console.log(error); })
                        .finally()
                    })
                },
                ParseIcons: function () {

                    var category = { "base": "../images/pins-pinocchio.svg" };
                    for (var i = 0; i < this.AreeTematiche.length; i++) {
                        var key = this.AreeTematiche[i].Name.toLowerCase().replaceAll(' ', '_');
                        var value = this.AreeTematiche[i].MarkerImage;
                        category[key] = value;
                    }

                    for (var i = 0; i < this.PuntiStorici.length; i++) {
                        var key = this.PuntiStorici[i].Name.toLowerCase().replaceAll(' ', '_');
                        var value = this.PuntiStorici[i].MarkerImage;
                        category[key] = value;
                    }

                    for (var i = 0; i < this.Servizi.length; i++) {
                        var key = this.Servizi[i].Name.toLowerCase().replaceAll(' ', '_');
                        var value = this.Servizi[i].MarkerImage;
                        category[key] = value;
                    }
                   
                   return JSON.stringify(category);
                },
                ArrayToString: function (arraytoconvert) {
                    return Array.prototype.map.call(arraytoconvert, function (item) { return item.EntityId; }).join(",");
                },
                SetStoreLocator: function (Stores, Icons) {
                    $('.map_container').storeLocator({
                        remote: Stores,
                        categoriesOptions: {
                            showFilter: false,
                            template: '',
                            icons: JSON.parse(Icons)
                        },
                        mapOptions: {
                            zoom: 1,
                            maxZoom: 20,
                            mapTypeId: 'satellite'
                        },
                        detailsOptions: {
                            panorama: {
                                showPanorama: false
                            }
                        },
                        searchOptions: {
                            show: false
                        },
                        geoLocationOptions: {
                            show: false,
                            position: google.maps.ControlPosition.TOP_LEFT
                        },
                        autocompleteOptions: {
                            show: false
                        },
                        routeOptions: {
                            show: true,
                            headline: '<h3>Indicazioni</h3>',
                            closeHtml: '<span class="ml-3"><img src="../images/close.svg" alt="Close"></span>',
                        },
                        onUpdateList: function () {
                            
                        },
                        onUpdateDetail: function () {
                            var current = 0,
                                items = $('.result_item_detail_info .slider_container div'),
                                itemsLength = items.length;

                            items.hide();
                            showItem();

                            function showItem() {
                                var item = items.eq(current);
                                items.hide();
                                item.css('display', 'inline-block');
                            }

                            $(document).on('click', '.result_item_detail_info .slider_container .next', function () {
                                current += 1;
                                if (current > itemsLength - 1) {
                                    current = 0;
                                }
                                showItem();
                            });

                            $(document).on('click', '.result_item_detail_info .slider_container .prev', function () {
                               /* console.log(itemsLength)*/
                                current -= 1;
                                if (current < 0) {
                                    current = itemsLength - 1;
                                }
                                showItem();
                            });
                        }
                    });
                },
                Filtra: function (event) {
                    event.preventDefault();

                    var UrlBuilder = "";
                    if (this.SelectedAreeTematiche && this.SelectedAreeTematiche.length > 0) {
                        UrlBuilder = "?at=" + this.ArrayToString(this.SelectedAreeTematiche);
                    }

                    if (this.SelectedPuntiStorici && this.SelectedPuntiStorici.length > 0) {
                        UrlBuilder = ((UrlBuilder) ? UrlBuilder + "&" : "?") + "ps=" + this.ArrayToString(this.SelectedPuntiStorici);
                    }

                    if (this.SelectedServizi && this.SelectedServizi.length > 0) {
                        UrlBuilder = ((UrlBuilder) ? UrlBuilder + "&" : "?") + "sv=" + this.ArrayToString(this.SelectedServizi);
                    }

                    window.location.href = window.location.href.split('?')[0] + UrlBuilder;
                },
                Reset: function(event) {
                    event.preventDefault();

                    window.location.href = window.location.href.split('?')[0]
                }
            }
        });
    }

    //#endregion

    $(".condividi").on("click", function (event) {
        event.preventDefault();
    });

});

document.addEventListener("DOMContentLoaded", function (event) {

    // Uses sharer.js 
    //  https://ellisonleao.github.io/sharer.js/#twitter	
    var url = window.location.href;
    var title = document.title;
    var subject = "";
    var via = "Parco_Pinocchio";

   //facebook
    $('#share-fb').attr('data-url', url).attr('data-sharer', 'facebook');
    //twitter
    $('#share-tw').attr('data-url', url).attr('data-title', title).attr('data-via', via).attr('data-sharer', 'twitter');
    //linkedin
    $('#share-li').attr('data-url', url).attr('data-sharer', 'linkedin');
    //email
    $('#share-em').attr('data-url', url).attr('data-title', title).attr('data-subject', subject).attr('data-sharer', 'email');

    //Prevent basic click behavior
    $(".sharer button").on('click', function (e) {
        e.preventDefault();
    });

});